import logoWhite from '../assets/img/JIFULogo-White.svg'
import search from '../assets/img/search-normal.svg'
import france from '../assets/img/france.png'
import germany from '../assets/img/germany.png'
import uk from '../assets/img/united-kingdom.png'
import us from '../assets/img/united-states.png'
import notification from '../assets/img/notification-bing.svg'
import profile from '../assets/img/profile-circle.svg'
import BannerBg from '../assets/img/bannerBg.jpg'
import FeatureLogo from '../assets/img/FeatureLogo.svg'
import feature1 from '../assets/img/feature1.svg'
import feature2 from '../assets/img/feature2.svg'
import feature3 from '../assets/img/feature3.svg'
import feature4 from '../assets/img/feature4.svg'
import cover1 from '../assets/img/Cover1.jpg'
import cover2 from '../assets/img/Cover2.jpg'
import cover3 from '../assets/img/Cover3.jpg'
import cover4 from '../assets/img/Cover4.jpg'
import cover5 from '../assets/img/Cover5.jpg'
import cover6 from '../assets/img/Cover6.jpg'
import chanelLogo1 from '../assets/img/chanelLogo1.svg'
import chanelLogo2 from '../assets/img/channelLogo2.svg'
import chanelLogo3 from '../assets/img/channelLogo3.svg'
import chanelLogo4 from '../assets/img/chanelLogo4.svg'
import chanelLogo5 from '../assets/img/chanelLogo5.svg'
import chanelLogo6 from '../assets/img/chanelLogo6.svg'
import arrow from '../assets/img/Arrow.svg'
import member1 from '../assets/img/member1.jpg'
import member2 from '../assets/img/member2.jpg'
import edu1 from '../assets/img/edu1.jpg'
import edu2 from '../assets/img/edu2.jpg'
import edu3 from '../assets/img/edu3.jpg'
import eduLogo1 from '../assets/img/eduLogo1.jpg'
import eduLogo2 from '../assets/img/eduLogo2.jpg'
import eduLogo3 from '../assets/img/eduLogo3.jpg'
import liveSearchBg from '../assets/img/liveSearchBg.jpg'
import liveLogo from '../assets/img/liveLogo.svg'
import avatar1 from '../assets/img/avatar/avatar1.png'
import avatar2 from '../assets/img/avatar/avatar2.png'
import avatar3 from '../assets/img/avatar/avatar3.png'
import avatar4 from '../assets/img/avatar/avatar4.png'
import avatar5 from '../assets/img/avatar/avatar5.png'
import avatar6 from '../assets/img/avatar/avatar6.png'
import avatar7 from '../assets/img/avatar/avatar7.png'
import avatar8 from '../assets/img/avatar/avatar8.png'
import avatar9 from '../assets/img/avatar/avatar9.png'
import avatar10 from '../assets/img/avatar/avatar10.png'
import special from '../assets/img/speaIMg.png'
import people from '../assets/img/people.svg'
import VideoFeature from '../assets/img/VideoFeature.png'
import avatarL from '../assets/img/avatarrl.png'
import play from '../assets/img/play.svg'
import record from '../assets/img/record.svg'
import refresh from '../assets/img/refresh.svg'
import VideoPlay from '../assets/img/VideoPlay.svg'
import VideoSlide1 from '../assets/img/VideoSlide1.jpg'
import VideoSlide2 from '../assets/img/VideoSlide2.jpg'
import VideoSlide3 from '../assets/img/VideoSlide3.jpg'
import chat from '../assets/img/chat.svg'
import chatAvatar from '../assets/img/chatAvatar.png'
import typing from '../assets/img/typing.png'
import favorite from '../assets/img/favorite.svg'
import loginBg from '../assets/img/loginBg.jpg'
import loginLogo from '../assets/img/loginLogo.svg'
import acdemyLogo from '../assets/img/logo/acdemyLogo.svg'
import airplane from '../assets/img/icon/airplane.svg'
import dashboard from '../assets/img/icon/dashboard.svg'
import graph from '../assets/img/icon/graph.svg'
import group_people from '../assets/img/icon/group_people.svg'
import health from '../assets/img/icon/health.svg'
import homeTrend from '../assets/img/icon/home-trend-up.svg'
import user from '../assets/img/icon/user.svg'
import Announcements from '../assets/img/icon/Announcements.svg'
import Badge from '../assets/img/icon/Badge.svg'
import education from '../assets/img/icon/education.svg'
import dashboardBg from '../assets/img/dashboardBg.jpg'
import ac1 from '../assets/img/academy/ac1.png'
import ac2 from '../assets/img/academy/ac2.png'
import ac3 from '../assets/img/academy/ac3.png'
import ac4 from '../assets/img/academy/ac4.png'
import course1 from '../assets/img/course/course1.png'
import course2 from '../assets/img/course/course2.png'
import course3 from '../assets/img/course/course3.png'
import course4 from '../assets/img/course/course4.png'
import file from '../assets/img/file.svg'
import flag1 from '../assets/img/charts/flag1.png'
import flag2 from '../assets/img/charts/flag2.png'
import flag3 from '../assets/img/charts/flag3.png'
import flag4 from '../assets/img/charts/flag4.png'
import flag5 from '../assets/img/charts/flag5.png'
import ChartCover1 from '../assets/img/charts/cover1.png'
import ChartCover2 from '../assets/img/charts/cover2.png'
import ChartCover3 from '../assets/img/charts/cover3.png'
import ChartCover4 from '../assets/img/charts/cover4.png'
import ChartCover5 from '../assets/img/charts/cover5.png'
import ChartCover6 from '../assets/img/charts/cover6.png'
import ChartCover7 from '../assets/img/charts/cover7.png'
import ChartCover8 from '../assets/img/charts/cover8.png'
import ChartCover9 from '../assets/img/charts/cover9.png'
import post from '../assets/img/post.png'
import PostAvatar1 from '../assets/img/post/avatar1.png'
import PostAvatar2 from '../assets/img/post/avatar2.png'
import PostAvatar3 from '../assets/img/post/avatar3.png'
import PostAvatar4 from '../assets/img/post/avatar4.png'
import PostAvatar5 from '../assets/img/post/avatar5.png'
import PostAvatar6 from '../assets/img/post/avatar6.png'
import Share from '../assets/img/icon/sharesvg.svg'
import importIcon from '../assets/img/icon/import.svg'
import exportIcon from '../assets/img/icon/export.svg'
import greenCheck from '../assets/img/icon/greenCheck.svg'
import normalCheck from '../assets/img/icon/normalCheck.svg'
import image from '../assets/img/icon/image.svg'
import emoji from '../assets/img/icon/emoji.svg'
import voice from '../assets/img/icon/voice.svg'
import camera from '../assets/img/icon/camer.svg'
import Like from '../assets/img/icon/Like.svg'
import exportChat from '../assets/img/icon/exportChat.svg'
import chat1 from '../assets/img/chatApp/avatar.png'
import chatImage from '../assets/img/chat/chat1.png'
import media1 from '../assets/img/chat/media1.png'
import media2 from '../assets/img/chat/media2.png'
import media3 from '../assets/img/chat/media3.png'
import media4 from '../assets/img/chat/media4.png'









export const Img ={
    media1,
    media2,
    media3,
    media4,
    chatImage,
    post,
    PostAvatar1,
    PostAvatar2,
    PostAvatar3,
    PostAvatar4,
    PostAvatar5,
    PostAvatar6,
    ChartCover1,
    ChartCover2,
    ChartCover3,
    ChartCover4,
    ChartCover5,
    ChartCover6,
    ChartCover7,
    ChartCover8,
    ChartCover9,
    file,
    course1,
    course2,
    course3,
    course4,
    ac1,
    ac2,
    ac3,
    ac4,
    logoWhite,
    search,
    france,
    germany,
    uk,
    us,
    notification,
    profile,
    BannerBg,
    FeatureLogo,
    feature1,
    feature2,
    feature3,
    feature4,
    cover1,
    cover2,
    cover3,
    cover4,
    cover5,
    cover6,
    chanelLogo1,
    chanelLogo2,
    chanelLogo3,
    chanelLogo4,
    chanelLogo5,
    chanelLogo6,
    arrow,
    member1,
    member2,
    edu1,
    edu2,
    edu3,
    eduLogo1,
    eduLogo2,
    eduLogo3,
    liveSearchBg,
    liveLogo,
    avatar1,
    avatar2,
    avatar3,
    avatar4,
    avatar5,
    avatar6,
    avatar7,
    avatar8,
    avatar9,
    avatar10,
    special,
    people,
    VideoFeature,
    avatarL,
    play,
    record,
    refresh,
    VideoPlay,
    VideoSlide1,
    VideoSlide2,
    VideoSlide3,
    chat,
    chatAvatar,
    typing,
    favorite,
    loginBg,
    loginLogo,
    acdemyLogo,
    dashboardBg,
    flag1,
    flag2,
    flag3,
    flag4,
    flag5,
    chat1
}

export const Icon ={
    greenCheck,
    normalCheck,
    exportIcon,
    importIcon,
    dashboard,
    airplane,
    graph,
    group_people,
    health,
    homeTrend,
    user,
    education,
    Announcements,
    Badge,
    Share,
    camera,
    image,
    voice,
    emoji,
    Like,
    exportChat
}